<h2>{{ editTitle }}</h2>
<div class="content-container">
  <div class="flex-row">
    <!-- Column left -->
    <div class="flex-col" style="margin-right: 40px">
      <div class="flex-row field-input">
        <label>Hoogte</label>
        <mat-form-field appearance="outline">
          <input
            type="number"
            matInput
            [(ngModel)]="productSize.height"
            required
          />
          <div matSuffix>{{ 'cm' }}</div>
        </mat-form-field>
      </div>
      <div class="flex-row field-input">
        <label>Breedte</label>
        <mat-form-field appearance="outline">
          <input
            type="number"
            matInput
            [(ngModel)]="productSize.width"
            required
          />
          <div matSuffix>{{ 'cm' }}</div>
        </mat-form-field>
      </div>
      <div class="flex-row field-input">
        <label>Bord type</label>
        <mat-form-field appearance="outline">
          <mat-select
            matInput
            placeholder="Maak een keuze"
            [(ngModel)]="productSize.boardType"
            [compareWith]="compareBoardType"
            required
          >
            <mat-option
              *ngFor="let option of boardTypeChoices"
              [value]="option"
            >
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="flex-row field-input">
        <label>Plaatsing</label>
        <mat-form-field appearance="outline">
          <mat-select
            matInput
            placeholder="Maak een keuze"
            [(ngModel)]="productSize.placementType"
            [compareWith]="comparePlacementType"
            required
          >
            <mat-option
              *ngFor="let option of placementTypeChoices"
              [value]="option"
            >
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="flex-row field-input">
        <label>Materiaal</label>
        <mat-form-field appearance="outline">
          <mat-select
            matInput
            placeholder="Maak een keuze"
            [(ngModel)]="productSize.material"
            [compareWith]="compareMaterials"
            required
          >
            <mat-option
              *ngFor="let option of materialTypeChoices"
              [value]="option"
            >
              {{ option.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="flex-row field-input">
        <label>Tijd ontwerper</label>
        <mat-form-field appearance="outline">
          <input
            type="number"
            matInput
            [(ngModel)]="productSize.designerMinutes"
          />
          <div matSuffix>{{ 'min' }}</div>
        </mat-form-field>
      </div>
      <div class="flex-row field-input">
        <label>Tijd plaatsing</label>
        <mat-form-field appearance="outline">
          <input
            type="number"
            matInput
            [(ngModel)]="productSize.placerMinutes"
          />
          <div matSuffix>{{ 'min' }}</div>
        </mat-form-field>
      </div>
      <div class="flex-row field-input">
        <label>Tijd weghalen</label>
        <mat-form-field appearance="outline">
          <input
            type="number"
            matInput
            [(ngModel)]="productSize.removalMinutes"
          />
          <div matSuffix>{{ 'min' }}</div>
        </mat-form-field>
      </div>
      <div class="flex-row field-input">
        <label>Aantal installateurs</label>
        <div>
          <mat-form-field appearance="outline">
            <input
              type="number"
              matInput
              [(ngModel)]="productSize.nbInstallersRequired"
              required
            />
          </mat-form-field>
        </div>
      </div>
      <div class="flex-row field-input">
        <label>Afstand tot onderkant bord</label>
        <div>
          <mat-form-field appearance="outline">
            <input
              type="number"
              matInput
              [(ngModel)]="productSize.cmToBottom"
              required
            />
            <div matSuffix>{{ 'cm' }}</div>
          </mat-form-field>
        </div>
      </div>
    </div>

    <!-- Column right -->
    <div class="flex-col">
      <div class="flex-row field-input">
        <label>Aanmaakprijs</label>
        <mat-form-field appearance="outline">
          <mat-icon matPrefix>euro_symbol</mat-icon>
          <input
            [ngModel]="productSize.productionPrice | asFormatDecimal : true : 2"
            (ngModelChange)="
              productionPriceSubject.next($event); onProductionPriceChange()
            "
            class="text-right"
            matInput
            mask="0*,00"
            [dropSpecialCharacters]="false"
            required
          />
        </mat-form-field>
      </div>
      <div class="flex-row field-input">
        <label>Retail Aanmaakprijs</label>
        <mat-form-field appearance="outline">
          <mat-icon matPrefix>euro_symbol</mat-icon>
          <input
            [ngModel]="
              productSize.productionRetailPrice | asFormatDecimal : true : 2
            "
            (ngModelChange)="
              productionRetailPriceSubject.next($event);
              onProductionRetailPriceChange()
            "
            class="text-right"
            matInput
            mask="0*,00"
            [dropSpecialCharacters]="false"
          />
        </mat-form-field>
      </div>
      <div class="flex-row field-input">
        <label>Plaatsingsprijs</label>
        <mat-form-field appearance="outline">
          <mat-icon matPrefix>euro_symbol</mat-icon>
          <input
            [ngModel]="productSize.placementPrice | asFormatDecimal : true : 2"
            (ngModelChange)="
              placementPriceSubject.next($event); onPlacementPriceChange()
            "
            class="text-right"
            matInput
            mask="0*,00"
            [dropSpecialCharacters]="false"
            required
          />
        </mat-form-field>
      </div>
      <div class="flex-row field-input">
        <label>Retail Plaatsingsprijs</label>
        <mat-form-field appearance="outline">
          <mat-icon matPrefix>euro_symbol</mat-icon>
          <input
            [ngModel]="
              productSize.placementRetailPrice | asFormatDecimal : true : 2
            "
            (ngModelChange)="
              placementRetailPriceSubject.next($event);
              onPlacementRetailPriceChange()
            "
            class="text-right"
            matInput
            mask="0*,00"
            [dropSpecialCharacters]="false"
          />
        </mat-form-field>
      </div>
      <div class="flex-row field-input">
        <label>Som</label>
        <mat-form-field appearance="outline">
          <mat-icon matPrefix>euro_symbol</mat-icon>
          <input
            class="text-right"
            matInput
            [disabled]="true"
            [value]="sumDisplay | asFormatDecimal : true : 2"
          />
        </mat-form-field>
      </div>
      <div class="flex-row field-input">
        <label>Retail Som</label>
        <mat-form-field appearance="outline">
          <mat-icon matPrefix>euro_symbol</mat-icon>
          <input
            class="text-right"
            matInput
            [disabled]="true"
            [value]="retailSumDisplay | asFormatDecimal : true : 2"
          />
        </mat-form-field>
      </div>
      <div class="flex-row field-input">
        <label>Geschilderde palen prijs</label>
        <mat-form-field appearance="outline">
          <mat-icon matPrefix>euro_symbol</mat-icon>
          <input
            [ngModel]="
              productSize.paintedPostsPrice | asFormatDecimal : true : 2
            "
            (ngModelChange)="
              paintedPostsPriceSubject.next($event); onPaintedPostsPriceChange()
            "
            class="text-right"
            matInput
            mask="0*,00"
            [dropSpecialCharacters]="false"
            required
          />
        </mat-form-field>
      </div>
      <div class="flex-row field-input">
        <label>Transportprijs</label>
        <mat-form-field appearance="outline">
          <mat-icon matPrefix>euro_symbol</mat-icon>
          <input
            [ngModel]="productSize.transportPrice | asFormatDecimal : true : 2"
            (ngModelChange)="transportPriceSubject.next($event)"
            class="text-right"
            matInput
            mask="0*,00"
            [dropSpecialCharacters]="false"
            required
          />
        </mat-form-field>
      </div>
      <div class="flex-row field-input">
        <label>Weghaalprijs</label>
        <mat-form-field appearance="outline">
          <mat-icon matPrefix>euro_symbol</mat-icon>
          <input
            [ngModel]="productSize.removalPrice | asFormatDecimal : true : 2"
            (ngModelChange)="removalPriceSubject.next($event)"
            class="text-right"
            matInput
            mask="0*,00"
            [dropSpecialCharacters]="false"
            required
          />
        </mat-form-field>
      </div>
      <div class="flex-row field-input">
        <label>Recyclagekosten</label>
        <mat-form-field appearance="outline">
          <mat-icon matPrefix>euro_symbol</mat-icon>
          <input
            [ngModel]="productSize.recyclePrice | asFormatDecimal : true : 2"
            (ngModelChange)="recyclePriceSubject.next($event)"
            class="text-right"
            matInput
            mask="0*,00"
            [dropSpecialCharacters]="false"
            required
          />
        </mat-form-field>
      </div>
    </div>
  </div>

  <file-picker
    [title]="'Afbeeldingen'"
    [subtitle]="'Kies afbeelding'"
    [inputProductSize]="productSize"
    [formSection]="'signSizeEdit'"
  ></file-picker>

  <h3>Constructiematerialen</h3>
  <div class="flex-col">
    <div class="flex-table" style="margin-bottom: 10px">
      <div class="flex-header-row">
        <div class="flex-2">Item</div>
        <div class="flex-2">Lengte (cm)</div>
        <div class="flex-2">Beschrijving</div>
        <div class="flex-2">Aantal</div>
        <div class="flex-1"></div>
      </div>
      <div
        class="flex-table-row"
        *ngFor="
          let material of productSize.requiredConstructionMaterials;
          index as i
        "
      >
        <div class="flex-table-cell flex-2">
          <mat-form-field appearance="outline">
            <mat-select
              matInput
              [(ngModel)]="material.signConstructionMaterialType"
              [compareWith]="compareConstructionMaterialType"
            >
              <mat-option
                *ngFor="let option of constructionMaterialTypeChoices"
                [value]="option"
              >
                {{ option ? option.label : 'Andere' }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="flex-table-cell flex-2">
          <mat-form-field
            *ngIf="
              material.signConstructionMaterialType &&
              getConstructionMaterialTypeLengthChoices(
                material.signConstructionMaterialType
              )
            "
            appearance="outline"
          >
            <mat-select
              matInput
              placeholder="Kies lengte"
              [(ngModel)]="material.signConstructionMaterialLength"
              required
            >
              <mat-option
                *ngFor="
                  let option of getConstructionMaterialTypeLengthChoices(
                    material.signConstructionMaterialType
                  )
                "
                [value]="option"
              >
                {{ option }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="flex-table-cell flex-2">
          <mat-form-field appearance="outline">
            <input matInput [(ngModel)]="material.description" />
          </mat-form-field>
        </div>
        <div class="flex-table-cell flex-2">
          <mat-form-field appearance="outline">
            <input
              type="number"
              matInput
              [(ngModel)]="material.amount"
              required
            />
          </mat-form-field>
        </div>
        <div
          class="flex-table-cell center flex-1 clickable"
          (click)="removeMaterial(i)"
        >
          <mat-icon svgIcon="close"></mat-icon>
        </div>
      </div>
    </div>
    <div class="pull-left clickable" (click)="addConstructionMaterial()">
      <mat-icon svgIcon="add"></mat-icon>
    </div>
  </div>
</div>

<div class="confirm-container border-top">
  <button class="btn button" type="button" (click)="save()">
    <span>Opslaan</span>
  </button>
</div>
